export default __webpack_public_path__ + "assets/imac.e8f37588.svg";